import { ClickAndReserveFeatureConfigEnum } from '@grandvisionhq/state';

const getClickAndReserveCtaLabelKey = (clickAndReserveFeatureConfig)=>{
    switch(clickAndReserveFeatureConfig){
        case ClickAndReserveFeatureConfigEnum.STOCK:
            return 'products.actions.checkStoreAvailability';
        case ClickAndReserveFeatureConfigEnum.STOCK_RESERVATION:
            return 'products.actions.checkStoreAvailabilityReservation';
        case ClickAndReserveFeatureConfigEnum.STOCK_RESERVATION_APPOINTMENT:
            // TODO: Add this label once we move to increment 3.
            return 'products.actions.checkStoreAvailabilityReservationAppointments';
        default:
            return '';
    }
};

export { getClickAndReserveCtaLabelKey };
//# sourceMappingURL=get-click-and-reserve-cta-label-key.js.map
